<!-- src/app/components/corporate/corporate-filters-bar/corporate-filters-bar.component.html -->
<div class="filters-bar card">
	<div class="grid align-items-center">
		<div class="filter-block" *ngIf="(organisations?.length ?? 0) > 1">
			<label class="filter-label">Organisation</label>
			<p-dropdown
				[options]="organisations"
				optionLabel="name"
				optionValue="id"
				[(ngModel)]="selectedOrganisationId"
				(onChange)="onOrganisationChange()"
				placeholder="Select Organisation"
			></p-dropdown>
		</div>

		<div class="col-12 md:col-4">
			<label class="field-label">Property</label>
			<p-dropdown
				[options]="properties"
				optionLabel="name"
				optionValue="id"
				[(ngModel)]="selectedPropertyId"
				(onChange)="onPropertyChange()"
				placeholder="All properties"
				[showClear]="true"
			></p-dropdown>
		</div>

		<div class="col-12 md:col-5">
			<label class="field-label">Date Range</label>
			<p-selectButton
				[options]="presetOptions"
				optionLabel="label"
				optionValue="value"
				[(ngModel)]="preset"
				(onChange)="onPresetChange()"
				styleClass="w-full"
			></p-selectButton>
		</div>

		<div class="col-12 md:col-3">
			<label class="field-label">Custom Range</label>
			<p-calendar
				[disabled]="preset !== 'custom'"
				selectionMode="range"
				[readonlyInput]="true"
				[(ngModel)]="customRange"
				(onSelect)="onCustomRangeChange()"
				dateFormat="dd/mm/yy"
				styleClass="w-full"
				placeholder="Select range"
			></p-calendar>
		</div>
	</div>
</div>
